import script from "./VisitHistoryReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitHistoryReportTable.vue?vue&type=script&setup=true&lang=js"

import "./VisitHistoryReportTable.vue?vue&type=style&index=0&id=367298ab&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367298ab"]])

export default __exports__